import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';

import { MatDialog } from '@angular/material/dialog';
import { PedidoRelatorioElement } from '../../interfaces/pedido.relatorio';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';

import { ExcelService } from '../../services/excel.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { ProdutoConsultaElement, ProdutoRelatorioElement } from '../../interfaces/produtos.consulta';


@Component({
  selector: 'app-relatorio-vendas',
  templateUrl: './relatorio-vendas.component.html',
  styleUrls: ['./relatorio-vendas.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioVendasComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  bCaracterEspecial: boolean = false;
  range: FormGroup;
  datePickerRotaControl: FormControl;

  auxPedidos: PedidoRelatorioElement[] = [];
  aProdutosVendidos: ProdutoRelatorioElement[] = [];
  totalLucroProduto: number = 0;
  totalProdutosVendidos: number = 0;

  somaTotal: number = 0;
  contConfirmados: number = 0;
  contEmSeparacao: number = 0;
  contEmRota: number = 0;
  contEntregues: number = 0;
  contCancelados: number = 0;
  //Pagamentos
  contPagamentoPendente: number = 0;
  contPagamentoConfirmado: number = 0;
  contPagamentoCancelado: number = 0;
  contPagamentoBoleto: number = 0;
  contPagamentoCredito: number = 0;
  contPagamentoDebito: number = 0;
  contPagamentDinheiro: number = 0;

  sBuscaStatusPedido: string = 'Todos';
  aTiposBuscaStatusPedido: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Todos - exceto cancelados', name: 'Todos - exceto cancelados' },
    { value: 'Confirmado', name: 'Confirmados' },
    { value: 'Em separação', name: 'Em separação' },
    { value: 'Em rota', name: 'Em rota' },
    { value: 'Entregue', name: 'Entregues' },
    { value: 'Cancelado', name: 'Cancelados' },
  ];

  sBuscaStatusPagamento: string = 'Todos';
  aTiposStatusPagamento: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Pendente', name: 'Pendentes' },
    { value: 'Pago', name: 'Pagos' },
    { value: 'Cancelado', name: 'Cancelados' },
  ];

  sBuscaCidade: string = 'Todas';
  aTodasCidades: any[] = [];
  aCidades: any[] = [];

  sBuscaUF: string;
  aUFs: any[] = [];

  sBuscaVendedor: string = 'Todos';
  aVendedores: any[] = [];

  sBuscaProduto: string = 'Todos';
  sBuscaIdProduto: string = 'Todos';
  aProdutos: any[] = [];
  aProdutosFiltrados: any[] = [];

  maxDate: Date = new Date();
  minDate: Date = new Date(2021, 0, 1);

  $pedidos;

  tipoCadastro = 'Vendedor';

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private af: AngularFireAuth

  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });

    //const currentYear = new Date().getFullYear() -1;
    //this.minDate = new Date(2021, 0, 1);
  }

  ngOnInit(): void {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    this.datePickerRotaControl = new FormControl(new Date());

    this.range.get('start').patchValue(new Date());
    this.range.get('end').patchValue(new Date());

    //Recupera os funcionários / Vendedores
    this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
      this.aVendedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.Status && dados.Permissoes.Vender) {
            this.aVendedores.push({
              value: item.key,
              name: dados.Nome,
            });
          }
        });

        //Ordena alfabeticamente
        this.aVendedores.sort((a, b) => a.value.localeCompare(b.value));

        this.aVendedores.unshift({ value: 'Todos', name: 'Todos' });

        if (this.tipoCadastro === 'Vendedor') {
          this.sBuscaVendedor = this.uid;
        }
      }
    });

    this.usuarioService.getProdutos().pipe(take(1)).subscribe(snap => {
      this.aProdutos = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          this.aProdutos.push({
            value: item.key,
            name: `${dados.CodigoProduto} - ${dados.Nome}`,
            nomeBusca: dados.NomeBusca
          });
        });

        //Ordena alfabeticamente
        this.aProdutos.sort((a, b) => a.value.localeCompare(b.value));

        this.aProdutos.unshift({ value: 'Todos', name: 'Todos', nomeBusca: 'todos' });

        this.aProdutosFiltrados = this.aProdutos;

        if (this.tipoCadastro === 'Vendedor') {
          this.sBuscaProduto = 'Todos';
        }
      }
    });

    this.usuarioService.getCidades(this.uid).pipe(take(1)).subscribe(snap => {
      this.aCidades = [];
      let auxIndex;

      if (snap.length > 0) {
        var dados;
        var auxDadosCidade;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxIndex = this.aUFs.findIndex(x => x.value === item.key);

          if (auxIndex === -1) {
            this.aUFs.push({
              value: item.key,
              name: item.key,
            });
          }

          Object.keys(dados).forEach((key, index) => {
            auxDadosCidade = dados[key];
            if (auxDadosCidade.Status) {
              this.aTodasCidades.push({
                uf: item.key,
                value: auxDadosCidade.Cidade,
                name: auxDadosCidade.Cidade
              })
            }
          });


        });

        this.aUFs.sort((a, b) => a.name.localeCompare(b.name));
        this.aTodasCidades.sort((a, b) => a.name.localeCompare(b.name));

        this.sBuscaUF = 'MG';
        this.carregarCidades();
      }
    });
  }

  carregarCidades() {
    this.aCidades = [];
    for (let i = 0; i < this.aTodasCidades.length; i++) {
      if (this.aTodasCidades[i].uf === this.sBuscaUF) {
        this.aCidades.push({
          uf: this.aTodasCidades[i].key,
          value: this.aTodasCidades[i].value,
          name: this.aTodasCidades[i].name
        });
      }
    }

    this.aCidades.sort((a, b) => a.name.localeCompare(b.name));

    this.aCidades.unshift({
      uf: null,
      value: 'Todas',
      name: 'Todas'
    });

    this.sBuscaCidade = 'Todas';
  }

  onChangeNomeProduto(busca) {
    this.aProdutosFiltrados = this.aProdutos.filter(option => option.nomeBusca.toLowerCase().includes(busca));
  }

  selecionarProduto(prod) {
    console.log(prod)
    this.sBuscaIdProduto = prod;
  }

  buscarVendasPeriodo() {

    this.spinner.show('relatorio-vendas');
    let timestampInicio: Date = new Date(this.range.get('start').value);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.range.get('end').value);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);
    var difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

    if (difference >= -12) {
      this.somaTotal = 0;
      this.contConfirmados = 0;
      this.contEmSeparacao = 0;
      this.contEmRota = 0;
      this.contEntregues = 0;
      this.contCancelados = 0;
      this.contPagamentoPendente = 0;
      this.contPagamentoConfirmado = 0;
      this.contPagamentoCancelado = 0;
      this.contPagamentoBoleto = 0;
      this.contPagamentoCredito = 0;
      this.contPagamentoDebito = 0;
      this.contPagamentDinheiro = 0;

      if (this.uid === environment.idCliente) {
        this.$pedidos = this.usuarioService.getPedidosTimestamp(timestampInicio.getTime(), timestampFinal.getTime(), 'Período').pipe(take(1)).subscribe(snap => {

          if (snap.length > 0) {
            this.auxPedidos = [];
            this.aProdutosVendidos = [];
            this.totalLucroProduto = 0;
            this.totalProdutosVendidos = 0;
            var dados: any;

            snap.forEach((item, index) => {
              dados = item.payload.val();

              if (
                (this.validarFiltro('Status do pedido', dados.Status, null, null, item.key, null, null)) &&
                (this.validarFiltro('Status do pagamento', dados.StatusPagamento, null, null, item.key, null, null)) &&
                (this.validarFiltro('Vendedor', dados.IDVendedor, null, null, item.key, null, null)) &&
                (this.validarFiltro('Cidade', dados.Cidade, dados.UF, null, item.key, null, null)) &&
                (this.validarFiltro('Produtos', dados.Status, null, dados.Produtos, item.key, this.usuarioService.tratarData(dados.Timestamp), dados.StatusPagamento))
              ) {
                this.auxPedidos.push({
                  ID: item.key,
                  Bairro: dados.Bairro,
                  BandeiraCartao: dados.BandeiraCartao,
                  CEP: dados.CEP,
                  Cidade: dados.Cidade,
                  Complemento: dados.Complemento,
                  Email: dados.Email,
                  FormaPagamento: dados.FormaPagamento,
                  NumeroParcelas: dados.NumeroParcelas,
                  IDVendedor: dados.IDVendedor,
                  Logradouro: dados.Logradouro,
                  Nome: dados.Nome,
                  Numero: dados.Numero,
                  Observacao: dados.Observacao,
                  Referencia: dados.Referencia,
                  Status: dados.Status,
                  StatusPagamento: dados.StatusPagamento,
                  Telefone: dados.Telefone,
                  TelefoneSecundario: dados.TelefoneSecundario,
                  Total: 'R$ ' + dados.Total.toFixed(2).replace('.', ','),
                  UF: dados.UF,
                  Data: this.usuarioService.tratarData(dados.Timestamp),
                  Hora: this.usuarioService.tratarHora(dados.Timestamp),
                  DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '-',
                  HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '-',
                  DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '-',
                  HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '-',
                  DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '-',
                  HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '-',
                  DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '-',
                  HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '-',
                  MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '-',
                  DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '-',
                  Plataforma: dados.Plataforma,
                  IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '-',
                  Dispositivo: dados.Dispositivo
                });

                dados.Status !== 'Cancelado' || this.sBuscaStatusPedido === 'Cancelado' ? this.somaTotal += dados.Total : null;

                dados.Status === 'Confirmado' ? this.contConfirmados++ : null;
                dados.Status === 'Em separação' ? this.contEmSeparacao++ : null;
                dados.Status === 'Em rota' ? this.contEmRota++ : null;
                dados.Status === 'Entregue' ? this.contEntregues++ : null;
                dados.Status === 'Cancelado' ? this.contCancelados++ : null;

                dados.StatusPagamento === 'Pendente' ? this.contPagamentoPendente++ : null;
                dados.StatusPagamento === 'Pago' ? this.contPagamentoConfirmado++ : null;
                dados.StatusPagamento === 'Cancelado' ? this.contPagamentoCancelado++ : null;

                dados.FormaPagamento === 'Boleto' ? this.contPagamentoBoleto++ : null;
                dados.FormaPagamento === 'Cartão de crédito' ? this.contPagamentoCredito++ : null;
                dados.FormaPagamento === 'Cartão de débito' ? this.contPagamentoDebito++ : null;
                dados.FormaPagamento === 'Dinheiro' ? this.contPagamentDinheiro++ : null;
              }
            });
            // this.auxPedidos = this.auxPedidos.reverse();

            this.usuarioService.setLog("Consulta relatório de vendas: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

            this.bConsulta = true;

            console.log('this.aProdutosVendidos', this.aProdutosVendidos)

            setTimeout(() => this.spinner.hide('relatorio-vendas'), 300);
          } else {
            this.toastr.error("Não foi possível localizar pedidos!", 'Erro');
            setTimeout(() => this.spinner.hide('relatorio-vendas'), 300);
          }
        });
      } else {
        //Busca somente pedidos do vendedor
        this.$pedidos = this.usuarioService.getPedidosIDVendedorTimestamp(this.uid, timestampInicio.getTime(), timestampFinal.getTime()).pipe(take(1)).subscribe(snap => {

          if (snap.length > 0) {
            this.auxPedidos = [];
            var dados;

            snap.forEach((item, index) => {
              dados = item.payload.val();

              if (
                (this.validarFiltro('Status do pedido', dados.Status, null, null, null, null, null)) &&
                (this.validarFiltro('Status do pagamento', dados.StatusPagamento, null, null, null, null, null)) &&
                (this.validarFiltro('Vendedor', dados.IDVendedor, null, null, null, null, null)) &&
                (this.validarFiltro('Cidade', dados.Cidade, dados.UF, null, null, null, null))
              ) {
                this.auxPedidos.push({
                  ID: item.key,
                  Bairro: dados.Bairro,
                  BandeiraCartao: dados.BandeiraCartao,
                  CEP: dados.CEP,
                  Cidade: dados.Cidade,
                  Complemento: dados.Complemento,
                  Email: dados.Email,
                  FormaPagamento: dados.FormaPagamento,
                  NumeroParcelas: dados.NumeroParcelas,
                  IDVendedor: dados.IDVendedor,
                  Logradouro: dados.Logradouro,
                  Nome: dados.Nome,
                  Numero: dados.Numero,
                  Observacao: dados.Observacao,
                  Referencia: dados.Referencia,
                  Status: dados.Status,
                  StatusPagamento: dados.StatusPagamento,
                  Telefone: dados.Telefone,
                  TelefoneSecundario: dados.TelefoneSecundario,
                  Total: 'R$ ' + dados.Total.toFixed(2).replace('.', ','),
                  UF: dados.UF,
                  Data: this.usuarioService.tratarData(dados.Timestamp),
                  Hora: this.usuarioService.tratarHora(dados.Timestamp),
                  DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '-',
                  HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '-',
                  DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '-',
                  HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '-',
                  DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '-',
                  HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '-',
                  DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '-',
                  HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '-',
                  MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '-',
                  DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '-',
                  Plataforma: dados.Plataforma,
                  IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '-',
                  Dispositivo: dados.Dispositivo
                });

                dados.Status !== 'Cancelado' || this.sBuscaStatusPedido === 'Cancelado' ? this.somaTotal += dados.Total : null;

                dados.Status === 'Confirmado' ? this.contConfirmados++ : null;
                dados.Status === 'Em separação' ? this.contEmSeparacao++ : null;
                dados.Status === 'Em rota' ? this.contEmRota++ : null;
                dados.Status === 'Entregue' ? this.contEntregues++ : null;
                dados.Status === 'Cancelado' ? this.contCancelados++ : null;

                dados.StatusPagamento === 'Pendente' ? this.contPagamentoPendente++ : null;
                dados.StatusPagamento === 'Pago' ? this.contPagamentoConfirmado++ : null;
                dados.StatusPagamento === 'Cancelado' ? this.contPagamentoCancelado++ : null;

                dados.FormaPagamento === 'Boleto' ? this.contPagamentoBoleto++ : null;
                dados.FormaPagamento === 'Cartão de crédito' ? this.contPagamentoCredito++ : null;
                dados.FormaPagamento === 'Cartão de débito' ? this.contPagamentoDebito++ : null;
                dados.FormaPagamento === 'Dinheiro' ? this.contPagamentDinheiro++ : null;
              }
            });
            // this.auxPedidos = this.auxPedidos.reverse();

            this.usuarioService.setLog("Consulta relatório de vendas: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

            this.bConsulta = true;

            setTimeout(() => this.spinner.hide('relatorio-vendas'), 300);
          } else {
            this.toastr.error("Não foi possível localizar pedidos!", 'Erro');
            setTimeout(() => this.spinner.hide('relatorio-vendas'), 300);
          }
        });
      }
    } else {
      this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('relatorio-vendas'), 300);
    }
  }

  validarFiltro(tipo, status, uf, produtos, pedido, dataPedido, statusPagamento) {
    switch (tipo) {
      case 'Status do pedido':
        return this.sBuscaStatusPedido === 'Todos' ? true : (this.sBuscaStatusPedido === 'Todos - exceto cancelados' ? (status !== 'Cancelado' ? true : false) : status === this.sBuscaStatusPedido);

      case 'Status do pagamento':
        return this.sBuscaStatusPagamento === 'Todos' ? true : status === this.sBuscaStatusPagamento;

      case 'Vendedor':
        return this.sBuscaVendedor === 'Todos' ? true : status === this.sBuscaVendedor;

      case 'Cidade':
        return this.sBuscaCidade === 'Todas' ? uf === this.sBuscaUF ? true : false : status === this.sBuscaCidade && uf === this.sBuscaUF;

      case 'Produtos':
        if (this.sBuscaProduto === 'Todos') {
          produtos.forEach((produto: ProdutoConsultaElement) => {
            //@ts-ignore
            produto.Valor = produto.DescontoGrupoPromocional ? produto.ValorDesconto : produto.Valor;
            this.aProdutosVendidos.push({
              Pedido: pedido,
              Produto: `${produto.CodigoProduto} - ${produto.Nome}`,
              Data: dataPedido,
              //@ts-ignore
              Status: status,
              StatusPgt: statusPagamento,
              //@ts-ignore
              CustoCompra: (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? `R$ ${produto.CustoCompra.toFixed(2).replace('.', ',')}` : 'Não consta',
              ValorVenda: `R$ ${produto.Valor.toFixed(2).replace('.', ',')}`,
              QuantidadeComprada: produto.QuantidadeComprada ? `${produto.QuantidadeComprada}` : '-',
              //@ts-ignore
              LucroBruto: (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? `R$ ${((produto.Valor - produto.CustoCompra) * produto.QuantidadeComprada).toFixed(2).replace('.', ',')}` : `-`
            });
            //@ts-ignore
            this.totalProdutosVendidos += produto.QuantidadeComprada;
            //@ts-ignore
            this.totalLucroProduto += (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? (produto.Valor - produto.CustoCompra) * produto.QuantidadeComprada : 0;
          });
          return true;
        }
        else {
          let resposta = false;
          produtos.forEach((produto: ProdutoConsultaElement) => {
            if (produto.Key === this.sBuscaIdProduto) {
              //@ts-ignore
              produto.Valor = produto.DescontoGrupoPromocional ? produto.ValorDesconto : produto.Valor;
              this.aProdutosVendidos.push({
                Pedido: pedido,
                Produto: `${produto.CodigoProduto} - ${produto.Nome}`,
                Data: dataPedido,
                //@ts-ignore
                Status: status,
                StatusPgt: statusPagamento,
                //@ts-ignore
                CustoCompra: (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? `R$ ${produto.CustoCompra.toFixed(2).replace('.', ',')}` : 'Não consta',
                ValorVenda: `R$ ${produto.Valor.toFixed(2).replace('.', ',')}`,
                QuantidadeComprada: produto.QuantidadeComprada ? `${produto.QuantidadeComprada}` : '-',
                //@ts-ignore
                LucroBruto: (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? `R$ ${((produto.Valor - produto.CustoCompra) * produto.QuantidadeComprada).toFixed(2).replace('.', ',')}` : `-`
              });
              console.log('produto.CustoCompra', produto.CustoCompra)
              //@ts-ignore
              this.totalProdutosVendidos += produto.QuantidadeComprada;
              //@ts-ignore
              this.totalLucroProduto += (produto.CustoCompra && produto.CustoCompra !== 0 && produto.CustoCompra !== "") ? (produto.Valor - produto.CustoCompra) * produto.QuantidadeComprada : 0;
              resposta = true;
            }
          });
          return resposta;
        }

      default: return false;
    }
  }

  exportarRelatorioProdutos() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo, true)
      }
    });
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: true },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo, false)
      }
    });
  }

  imprimir(tipo, b) {
    var date = new Date();
    date.setTime(this.range.get('start').value);
    var dateFinal = new Date();
    dateFinal.setTime(this.range.get('end').value);
    const map = {
      Soma: this.somaTotal,
      ContConfirmados: this.contConfirmados,
      ContEmSeparacao: this.contEmSeparacao,
      ContEnRota: this.contEmRota,
      ContEntregues: this.contEntregues,
      ContCancelados: this.contCancelados,
      ContPagamentoPendente: this.contPagamentoPendente,
      ContPagamentoConfirmado: this.contPagamentoConfirmado,
      ContPagamentoCancelado: this.contPagamentoCancelado,
      ContPagmentoBoleto: this.contPagamentoBoleto,
      ContPagamentoCredito: this.contPagamentoCredito,
      ContPagamentoDebito: this.contPagamentoDebito,
      ContPagamentoDinheiro: this.contPagamentDinheiro,
      Periodo: this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime())
    }

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];


        if (!b) {
          this.auxPedidos.forEach(dado => {
            var aux = [dado.ID, dado.Data, dado.Bairro, dado.Cidade, dado.Nome, dado.FormaPagamento, dado.StatusPagamento, dado.Status, dado.DataEntregue, dado.Total];
            corpo.push(aux);
          });
        } else {
          this.aProdutosVendidos.forEach(dado => {
            //@ts-ignore
            var aux = [dado.Pedido, dado.Produto, dado.Data, dado.Status, dado.StatusPgt, dado.CustoCompra, dado.ValorVenda, dado.QuantidadeComprada, dado.LucroBruto];
            corpo.push(aux);
          });
        }

        autoTable(doc, {
          head: [!b ?
            ["Pedido", "Data", "Bairro", "Cidade", "Cliente", "Forma de PGT", "Status PGT", "Status", "Data da entrega", "Total"] :
            ["Pedido", "Produto", "Data", "Status", "Status PGT", "Custo de compra", "Valor de venda", "Quantidade itens", "Lucro"]
          ],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [!b ?
            ["", "", "", "", "", "", "", "", "", "Total: R$ " + this.somaTotal.toFixed(2).replace('.', ',')] :
            ["", "", "", "", "", "", "", this.totalProdutosVendidos, "Total: R$ " + this.totalLucroProduto.toFixed(2).replace('.', ',')]
          ]
        });
        doc.save('Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de vendas em PDF. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()) + " Produto: " + this.sBuscaIdProduto, map, this.uid);
        break;

      //Excel
      case 1:
        this.excelService.exportAsExcelFile(!b ? this.auxPedidos : this.aProdutosVendidos, 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()));

        this.usuarioService.setLog("Exportou relatório de vendas em EXCEL. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);
        break;

      //CSV
      case 2:
        var options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()),
          useBom: true,
          noDownload: false,
          headers: !b ?
            ["Pedido", "Bairro", "Bandeira cartão", "CEP", "Cidade", "Complemento", "Email", "Forma de pagamento", "Número de parcelas", "IDVendedor", "Logradouro", "Nome", "Numero", "Observacao", "Referencia", "Status", "Status do pagamento", "Telefone", "Telefone secundário", "Total", "UF", "Data", "Hora", "Data da separação", "Hora da separação", "Data da rota", "Hora da rota", "Data da entrega", "Hora da entrega", "Data do cancelamento", "Hora do cancelamento", "Motivo do cancelamento", "Data e hora do pagamento", "Plataforma", "IDDispositivo", "Dispositivo"] :
            ["Pedido", "Produto", "Data", "Status", "Status PGT", "Custo de compra", "Valor de venda", "Quantidade itens", "Lucro"],
          nullToEmptyString: true,
        };

        new Angular5Csv(!b ? this.auxPedidos : this.aProdutosVendidos, 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), options);
        this.usuarioService.setLog("Exportou relatório de vendas em CSV. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);

        break;
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

}
